import { render, staticRenderFns } from "./DiscountModal.vue?vue&type=template&id=7403979b&scoped=true&"
import script from "./DiscountModal.vue?vue&type=script&lang=js&"
export * from "./DiscountModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscountModal.vue?vue&type=style&index=0&id=7403979b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403979b",
  null
  
)

export default component.exports